"use client"

import { getCustomerRefferal, getUserCredentialApi } from "@/services/Redux/Reducer/CustomerSlice";
import localStorageCall from "@/services/Methods/localstorage.hook";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { _getPrice, _getPriceForShareMyCart, _logoutFunction, _ProductStructure, storeAssigned } from "@/services/Methods/normalMethods";
import _ from "lodash";
import useIpDetection from "./useIpDetection";
import { _getWebCatId, getAllProductApiPagination } from "@/services/Redux/Reducer/AllProductSlice";
import { toast, Zoom } from "react-toastify";
const STORES = ['us', 'au', 'br', 'bs', 'ca', 'co', 'hk', 'id', 'jm', 'my', 'nz', 'pa', 'pe', 'ph', 'sg', 'eu', 'at', 'be', 'bg',
    'bw', 'ch', 'cy', 'cz', 'de', 'dk', 'ee', 'es', 'fi', 'fr', 'gb', 'gh', 'gr', 'hr', 'hu', 'ie', 'in', 'is', 'it', 'jp', 'mx',
    'ke', 'lt', 'mt', 'mz', 'na', 'nc', 'ng', 'nl', 'no', 'pl', 'pt', 're', 'ro', 'rs', 'ru', 'se', 'si', 'sk', 'tz', 'ug', 'za', 'zm', 'zw', 'tw', 'pf', 'mu', 'do', 'sr'];

const useRefferalHook = (props, section) => {

    const { pathname, router, isUserLogin, params, searchParams } = props;

    const dispatch = useDispatch();
    const [pageNotFound, setPageNotFound] = useState(false);
    const [urlRefferal, setUrlRefferal] = useState(null);
    const [isReferralLoading, setLoading] = useState(true);
    const [refferalCheckPopup, setRefferalCheckPopup] = useState(false);
    const { success } = useIpDetection(STORES, params?.store, router, pathname);

    useEffect(() => {
        const redirectTo = searchParams.get("redirectTo");
        if (redirectTo === '/main-enrollment' && isUserLogin) {
            console.log("inside-the-login-condition----------------------")
            _logoutFunction("notRedirect");
            router.push(`/${storeAssigned()}/main-enrollment`);
        }
    }, [])


    useEffect(() => {
        // if (section === 'urlRefferalCheck') {
        //     console.log("params?.store",params?.store)
        //     _checkRefferalCode(params?.store, section);

        //     // && _.includes(STORES, params?.store)
        // }
        if (pathname && !searchParams.get('ssokey') && _.includes(STORES, params?.store)) {
            setTimeout(() => setLoading(false), 2000);
        }
    }, [pathname]);
    useEffect(() => {
        if (section === 'urlRefferalCheck') {
            console.log("params?.store", params?.store)
            _checkRefferalCode(params?.store, section);

            // && _.includes(STORES, params?.store)
            if (searchParams.get('productCart')) {
                success();
            }
        }
    }, []);

    // console.log(localStorageCall().getItem("refferal_link"), 'dddddddddddddddddddddddddddddddd');

    function _handleYesClick(action = "no", refferalData) {
        if (action === 'yes') {
            localStorageCall().setItem("refferal_link", JSON.stringify(refferalData));
        }
        if (searchParams.get('partyPlanId')) {
            localStorageCall().setItem('partyPlanId', searchParams.get('partyPlanId'))
        }
        if (searchParams?.get('pid') && searchParams?.get('placement') && searchParams?.get('tree')) {
            if (isUserLogin) {
                _logoutFunction('notRedirect');
            }
            const TreeMoveData = {
                pid: searchParams.get('pid'),
                placementId: searchParams.get('placement'),
                treeType: searchParams.get('tree'),
                placementType: searchParams.get('placementType')
            }
            localStorageCall().setItem('TreeMoveData', JSON.stringify(TreeMoveData));
            // const URL = (searchParams.get('role') === 'customer') ? 'distributor' : 'distributor'
            const URL = (searchParams.get('role') === 'customer') ? 'main-enrollment' : 'main-enrollment'
            window?.location.assign(`/${storeAssigned()}/${URL}`);
        } else {
            const REDIRECT_PAGE = searchParams.get('redirectTo') ? searchParams.get('redirectTo') : "";
            if (REDIRECT_PAGE) {
                router.push(REDIRECT_PAGE ? `/${storeAssigned()}${REDIRECT_PAGE}` : `/${storeAssigned()}`);
            } else {
                router.push(`/${storeAssigned()}`)
            }
        }
    }

    const handleCloseShareIPPopup = () => {
        setLoading(true);
        localStorageCall().setItem("isIPCheckPopupOpen", 'false');
        const ShareRedirectToCountry = localStorageCall().getSingleItem('shareRedirectToCountry');
        const PRODUCT_CART = localStorageCall().getSingleItem('productCart');
        const CUSTOMER_TYPE = localStorageCall().getItem('customerTypeDescr');
        const SPLIT_MULTI_PRODUCT = _.split(PRODUCT_CART, ',');
        const TOAST_ID = "shared-cart-unavailable";
        console.log("SPLIT_MULTI_PRODUCT", SPLIT_MULTI_PRODUCT);
        dispatch(getAllProductApiPagination(0, _getWebCatId(ShareRedirectToCountry), (oldData) => {
            const OldResults = _.map(oldData, (row) => {
                let CONDITION = _.includes(['ambassador'], CUSTOMER_TYPE?.role) ? _getPriceForShareMyCart(row, 3, ShareRedirectToCountry) : _.includes(['member'], CUSTOMER_TYPE?.role) ? _getPriceForShareMyCart(row, 2, ShareRedirectToCountry) : _.includes(['VIP'], CUSTOMER_TYPE?.role) ? _getPriceForShareMyCart(row, 1, ShareRedirectToCountry) : _getPriceForShareMyCart(row, 2, ShareRedirectToCountry);
                if (CONDITION || (CONDITION === 0)) {
                    if (row?.itemPricing.find(data => data?.countryCode.toLowerCase() === ShareRedirectToCountry)) {
                        const data = _ProductStructure(row)
                        return data;
                    }
                }
            });
            const ADD_OLD_PRODUCTS = _.map(SPLIT_MULTI_PRODUCT, (el) => {
                const SPLIT_DATA = _.split(el, ':');
                const MATCHED_PRODUCTS_OLD = _.find(OldResults, { itemCode: SPLIT_DATA[0] });
                return MATCHED_PRODUCTS_OLD ? { ...MATCHED_PRODUCTS_OLD, frequency: SPLIT_DATA[2] === '2' ? 'autoship' : 'oneTime', quantity: +SPLIT_DATA[1], onlySubscription: SPLIT_DATA[3] === 'true' } : null;
            })

            dispatch(getAllProductApiPagination(0, _getWebCatId('All Products'), (data) => {
                const RESULTS = _.map(data, (row) => {
                    let CONDITION = _.includes(['ambassador'], CUSTOMER_TYPE?.role) ? _getPrice(row, 3) : _.includes(['member'], CUSTOMER_TYPE?.role) ? _getPrice(row, 2) : _.includes(['VIP'], CUSTOMER_TYPE?.role) ? _getPrice(row, 1) : _getPrice(row, 2);
                    if (CONDITION || (CONDITION === 0)) {
                        if (row?.itemPricing.find(data => data?.countryCode.toLowerCase() === storeAssigned())) {
                            const data = _ProductStructure(row)
                            return data;
                        }
                    }
                });
                console.log("RESULTS", RESULTS);
                const ADD_PRODUCTS = _.map(SPLIT_MULTI_PRODUCT, (el) => {
                    const SPLIT_DATA = _.split(el, ':');
                    console.log("SPLIT_DATA", SPLIT_DATA);
                    const originalCode = SPLIT_DATA[0];
                    const baseCode = originalCode.slice(0, -2);
                    const newCountryCode = storeAssigned().toUpperCase();
                    const transformedCode = `${baseCode}${newCountryCode}`;

                    const MATCHED_PRODUCTS = _.find(RESULTS, { itemCodeShareCart: baseCode });
                    console.log("MATCHED_PRODUCTS", MATCHED_PRODUCTS);
                    return MATCHED_PRODUCTS ? { ...MATCHED_PRODUCTS, frequency: SPLIT_DATA[2] === '2' ? 'autoship' : 'oneTime', quantity: +SPLIT_DATA[1], onlySubscription: SPLIT_DATA[3] === 'true' } : null;
                })

                const compactedProducts = _.compact(ADD_PRODUCTS);
                const unavailableProducts = _.filter(SPLIT_MULTI_PRODUCT, (el) => {
                    const SPLIT_DATA = _.split(el, ':');
                    const baseCode = SPLIT_DATA[0].slice(0, -2);
                    return !_.find(RESULTS, { itemCodeShareCart: baseCode });
                });

                const unavailableProductCodes = unavailableProducts.map(el => el.split(':')[0]);

                const OldProductTitles = _.filter(ADD_OLD_PRODUCTS, p =>
                    unavailableProductCodes.includes(p?.itemCode)
                )?.map(p => p.title);

                console.log(ADD_PRODUCTS, "ADD_PRODUCTS", unavailableProducts, OldProductTitles);
                localStorageCall().removeItem('shareRedirectToCountry');

                if (unavailableProducts.length > 0) {
                    setLoading(false);
                    if (!toast.isActive(TOAST_ID)) {
                        toast.info(
                            ({ closeToast }) => (
                                <div style={{ color: '#222', display: "flex", flexDirection: "column", padding: "15px" }}>
                                    <p>
                                        Some products in the shared cart are not available in your country:
                                        <br />
                                        <ul style={{ paddingLeft: '15px', listStyleType: 'disc', listStylePosition: 'outside', paddingTop: "20px" }}>
                                            {OldProductTitles?.map((title, index) => (
                                                <li key={index} style={{ fontSize: '15px', margin: -5, paddingTop: "10px", lineHeight: '1.4' }}>{title}</li>
                                            ))}
                                        </ul>
                                    </p>
                                    <button
                                        onClick={() => {
                                            closeToast();
                                            if (compactedProducts.length > 0) {
                                                localStorageCall().setItem('normalProducts', JSON.stringify(compactedProducts));
                                                setTimeout(() => {
                                                    window?.location.assign(`/${storeAssigned()}/checkout`);
                                                }, 1000);
                                            } else {
                                                setTimeout(() => {
                                                    window?.location.reload();
                                                }, 2000);
                                            }
                                        }}
                                        style={{
                                            marginTop: '10px',
                                            padding: '6px 12px',
                                            backgroundColor: '#333',
                                            color: '#fff',
                                            border: 'none',
                                            borderRadius: '4px',
                                            cursor: 'pointer',
                                            textAlign: "center",
                                            alignSelf: "center"
                                        }}
                                    >
                                        OK
                                    </button>
                                </div>
                            ),
                            {
                                toastId: TOAST_ID,
                                position: "top-center",
                                autoClose: false,
                                hideProgressBar: true,
                                closeOnClick: false,
                                pauseOnHover: false,
                                draggable: false,
                                closeButton: false,
                                icon: false,
                                style: {
                                    width: '400px',
                                    maxWidth: '90%',
                                },
                                transition: Zoom,
                            }
                        );
                    }
                } else if (compactedProducts.length > 0) {
                    localStorageCall().setItem('normalProducts', JSON.stringify(compactedProducts));
                    window?.location.assign(`/${storeAssigned()}/checkout`);
                }
            }))
        }));
    };

    function _checkRefferalCode(refferal, section = "refferalPopup", errorCallback) {
        if (!(STORES?.includes(params?.store))) {
            if (searchParams.get('ssokey')) {
                if (searchParams.get('partyPlanId')) {
                    localStorageCall().setItem('partyPlanId', searchParams.get('partyPlanId'))
                }
                const REDIRECT_PAGE = searchParams.get('redirectTo') ? searchParams.get('redirectTo') : "";
                dispatch(getUserCredentialApi(searchParams.get('ssokey'), router, REDIRECT_PAGE));
            } else {
                dispatch(getCustomerRefferal((data) => {
                    console.log("data    >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>", data)
                    if (data?.length === 0) {
                        // setPageNotFound(true);
                        router.push(`/${storeAssigned()}`)
                    } else {
                        const PRODUCT_CART = searchParams.get('productCart') ? searchParams.get('productCart') : "";
                        const CUSTOMER_TYPE = localStorageCall().getItem('customerTypeDescr');
                        if (PRODUCT_CART) {
                            const refferalData = { "id": data[0]?.customerId, "name": data[0]?.fullName || data[0]?.publicProfile?.fullName, "webalies": data[0]?.webAlias, userDetail: data?.[0] };
                            localStorageCall().setItem("refferal_link", JSON.stringify(refferalData));

                            const TreeMoveData = localStorageCall().getItem('TreeMoveData');

                            if (TreeMoveData && TreeMoveData?.pid !== data[0]?.customerId) {

                                localStorageCall().removeItem('TreeMoveData');

                            }
                            localStorageCall().removeItem("normalProducts");
                            if (searchParams.get('redirectTo') !== `/${storeAssigned()}`) {
                                localStorageCall().setItem('shareRedirectToCountry', searchParams.get('redirectTo')?.slice(1));
                                localStorageCall().setItem('isIPCheckPopupOpen', 'true');
                                localStorageCall().setItem('productCart', PRODUCT_CART);
                            } else {
                                const SPLIT_MULTI_PRODUCT = _.split(PRODUCT_CART, ',');
                                const TOAST_ID = "shared-cart-unavailable";
                                console.log("SPLIT_MULTI_PRODUCT", SPLIT_MULTI_PRODUCT);
                                dispatch(getAllProductApiPagination(0, _getWebCatId('All Products'), (data) => {
                                    const RESULTS = _.map(data, (row) => {
                                        let CONDITION = _.includes(['ambassador'], CUSTOMER_TYPE?.role) ? _getPrice(row, 3) : _.includes(['member'], CUSTOMER_TYPE?.role) ? _getPrice(row, 2) : _.includes(['VIP'], CUSTOMER_TYPE?.role) ? _getPrice(row, 1) : _getPrice(row, 2);
                                        if (CONDITION || (CONDITION === 0)) {
                                            if (row?.itemPricing.find(data => data?.countryCode.toLowerCase() === storeAssigned())) {
                                                const data = _ProductStructure(row)
                                                return data;
                                            }
                                        }
                                    });
                                    console.log("RESULTS", RESULTS);
                                    const ADD_PRODUCTS = _.map(SPLIT_MULTI_PRODUCT, (el) => {
                                        const SPLIT_DATA = _.split(el, ':');
                                        console.log("SPLIT_DATA", SPLIT_DATA);
                                        const originalCode = SPLIT_DATA[0];
                                        const baseCode = originalCode.slice(0, -2);
                                        const newCountryCode = storeAssigned().toUpperCase();
                                        const transformedCode = `${baseCode}${newCountryCode}`;

                                        const MATCHED_PRODUCTS = _.find(RESULTS, { itemCode: SPLIT_DATA[0] });
                                        console.log("MATCHED_PRODUCTS", MATCHED_PRODUCTS);
                                        return MATCHED_PRODUCTS ? { ...MATCHED_PRODUCTS, frequency: SPLIT_DATA[2] === '2' ? 'autoship' : 'oneTime', quantity: +SPLIT_DATA[1], onlySubscription: SPLIT_DATA[3] === 'true' } : null;
                                    })
                                    console.log(ADD_PRODUCTS, "ADD_PRODUCTS");
                                    if (_.compact(ADD_PRODUCTS).length > 0) {
                                        localStorageCall().setItem('normalProducts', JSON.stringify(_.compact(ADD_PRODUCTS)))
                                        window?.location.assign(`/${storeAssigned()}/checkout`);
                                    } else {
                                        if (!toast.isActive(TOAST_ID)) {
                                            toast.info(
                                                ({ closeToast }) => (
                                                    <div style={{ color: '#222', display: "flex", flexDirection: "column" }}>
                                                        <p>
                                                            Some products in the shared cart are not available in your country:
                                                            <br />
                                                            {/* <ul style={{ paddingLeft: '2px', listStyleType: 'disc', listStylePosition: 'inside' }}>
                                                                {OldProductTitles?.map((title, index) => (
                                                                    <li key={index}>{title}</li>
                                                                ))}
                                                            </ul> */}
                                                        </p>
                                                        <button
                                                            onClick={() => {
                                                                closeToast();
                                                                setTimeout(() => {
                                                                    window?.location.reload();
                                                                }, 2000);
                                                            }}
                                                            style={{
                                                                marginTop: '10px',
                                                                padding: '6px 12px',
                                                                backgroundColor: '#333',
                                                                color: '#fff',
                                                                border: 'none',
                                                                borderRadius: '4px',
                                                                cursor: 'pointer',
                                                                textAlign: "center",
                                                                alignSelf: "center"
                                                            }}
                                                        >
                                                            OK
                                                        </button>
                                                    </div>
                                                ),
                                                {
                                                    toastId: TOAST_ID,
                                                    position: "top-center",
                                                    autoClose: false,
                                                    hideProgressBar: true,
                                                    closeOnClick: false,
                                                    pauseOnHover: false,
                                                    draggable: false,
                                                    closeButton: false,
                                                    icon: false,
                                                    style: {
                                                        // background: '#8dfa00',
                                                        width: '400px',
                                                        maxWidth: '90%',
                                                    },
                                                    transition: Zoom,
                                                }
                                            );
                                        }
                                    }
                                }))
                            }
                        } else {

                            try {
                                const refferalData = { "id": data[0]?.customerId, "name": data[0]?.fullName || data[0]?.publicProfile?.fullName, "webalies": data[0]?.webAlias, userDetail: data?.[0] };
                                localStorageCall().setItem("refferal_link", JSON.stringify(refferalData));

                                const TreeMoveData = localStorageCall().getItem('TreeMoveData');

                                if (TreeMoveData && TreeMoveData?.pid !== data[0]?.customerId) {

                                    localStorageCall().removeItem('TreeMoveData');

                                }

                                // setUrlRefferal(refferalData);
                                // setRefferalCheckPopup(true);
                                if (searchParams?.get('pid') && searchParams?.get('placement') && searchParams?.get('tree')) {
                                    if (isUserLogin) {
                                        _logoutFunction('notRedirect');
                                    }
                                    const TreeMoveData = {
                                        pid: searchParams.get('pid'),
                                        placementId: searchParams.get('placement'),
                                        treeType: searchParams.get('tree'),
                                        placementType: searchParams.get('placementType')
                                    }
                                    localStorageCall().setItem('TreeMoveData', JSON.stringify(TreeMoveData));
                                    const URL = (searchParams.get('role') === 'customer') ? 'main-enrollment' : 'main-enrollment'
                                    window?.location.assign(`/${storeAssigned()}/${URL}`);
                                } else {
                                    if (isUserLogin) {
                                        _logoutFunction('notRedirect');
                                    }
                                    const REDIRECT_PAGE = searchParams.get('redirectTo') ? searchParams.get('redirectTo') : "";
                                    const WEBCAT_ID = searchParams.get('webCat') ? searchParams.get('webCat') : "";
                                    if (REDIRECT_PAGE && WEBCAT_ID) {
                                        window.location.assign(REDIRECT_PAGE ? `/${storeAssigned()}${REDIRECT_PAGE}?itemId=${WEBCAT_ID}` : `/${storeAssigned()}`);
                                    }
                                    else if (REDIRECT_PAGE) {
                                        window.location.assign(REDIRECT_PAGE ? `/${storeAssigned()}${REDIRECT_PAGE}` : `/${storeAssigned()}`);
                                    } else {

                                        // console.log("inside-the-last-condtion************************************");
                                        window.location.assign(`/${storeAssigned()}/main-enrollment`)
                                    }
                                }

                            } catch (err) {
                                console.log(err)
                            }
                        }
                    }
                }, refferal, 'urlRef'));
            }
        }
    }




    return ({
        pageNotFound, urlRefferal, setUrlRefferal, refferalCheckPopup, setRefferalCheckPopup,
        _checkRefferalCode,
        _handleYesClick,
        isReferralLoading,
        handleCloseShareIPPopup,
    })
};

export default useRefferalHook;